import { ChangeDetectorRef, Component, Injector, Input, ViewChild } from '@angular/core';
import { BaseEntityManagementSupported } from '../MixinComponents';
import { TranslateService } from '@ngx-translate/core';
import { PreferenceService } from '../../services/system/preference.service';
import { TenantCustomService } from '../../services/system/tenant-custom.service';
import { PiDataTableComponent } from '../../components/common/pi-data-table/pi-data-table.component';
import { CustomFieldsService } from '../../services/system/custom-fields.service';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-entity-management-support',
  templateUrl: './entity-management-support.component.html',
  styleUrls: ['./entity-management-support.component.scss']
})
export class EntityManagementSupportComponent extends BaseEntityManagementSupported {
  @ViewChild('modalContent') modalContent;
  @ViewChild('modalContentFooter') modalContentFooter;
  @ViewChild('dataTable') dataTable: PiDataTableComponent;
  // 子表对象
  @ViewChild('tableExpand') tableExpand;
  @Input() columnSettingName = ''
  @Input() viewMode: 'normal' | 'select' = 'normal';
  @Input() pageSize = 10;
  @Input() isPageOpen = false;

  // 子表展开的数据集
  tableExpandMap = {};
  baseHttpClient;
  constructor(public injector: Injector) {
    super();
    this.translateService = injector.get(TranslateService);
    this.basePreferenceService = injector.get(PreferenceService);
    this.baseTenantCustomService = injector.get(TenantCustomService);
    this.baseCustomFieldsService = injector.get(CustomFieldsService);
    this.baseHttpClient = injector.get(HttpClient);
    this.cdr = injector.get(ChangeDetectorRef);
    this.handleCancel = this.handleCancel.bind(this)
  }

  async init(entityService) {
    this.setEntityService(entityService);
    this.buildForm();
    this.controlSubscribe(this.detailForm)
    this.loadData();
    if (!this.dynamicColumn){
      this.loadColumnSettings();
    }
    this.loadCommonTranslation();
    await this.loadCustomFieldSettings();
  }

  getSelectedData() {
    return this.dataTable.getCheckedData();
  }

  getCurrentData() {
    return this.dataTable.getCurrentData();
  }

  // 展开子表
  async dataExpand($event) {
    if ($event.expand) {
      const detail = this.dataList.find(data => data[this.primaryKeyName] === $event.id);
      //  await this.entityService.searchById($event[this.primaryKeyName]).toPromise();
      if (detail && detail[this.bodyEntityName]) {
        let i = 1
        detail[this.bodyEntityName].map(detail => {
          detail.seq = i++;
        })
        this.tableExpandMap[$event.id] = detail[this.bodyEntityName]
      }
    }
  }

  // 重查时清空展开的子表信息
  tableExpandClear() {
    this.tableExpand.expandSet.clear()
  }

  // 下载文件
  downLoadfile(fileUrl, fileName) {
    try {
      this.baseHttpClient.get(fileUrl, { responseType: 'blob' }).subscribe(
        (response) => {
          const a = document.createElement('a')
          const objectUrl = URL.createObjectURL(response)
          a.href = objectUrl
          a.download = fileName;
          a.click();
          URL.revokeObjectURL(objectUrl);
        }
      )
    } catch (e) { }
  }
}
